module.exports = __webpack_public_path__ + "img/t0001.370de4ff.png";